import api from './api';

const CouponService = {
    validateCoupon: async (code, cartTotal) => {
        const response = await api.post('coupons/validate/', {
            code,
            cart_total: cartTotal
        });
        return response.data;
    }
};

export default CouponService;
